import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Depot from "../../planning/components/depots/depot";
import PlanningItemHeader from "../../planning/components/planning-item-header";
import PlanningItemHeaderBadge from "../../planning/components/planning-item-header-badge";
import { FontAwesomeDuoToneStyle } from "../../../../fontawesome";
import { Typography } from "@material-ui/core";

export const DepotSummary = ({
    location,
    timeString
}) => {

    return (
        <Depot 
            header={
                <PlanningItemHeader>
                    <PlanningItemHeaderBadge>
                        <FontAwesomeIcon icon={["fad", "clock"]} style={FontAwesomeDuoToneStyle} />
                        <Typography component="span">
                            {timeString}
                        </Typography>
                    </PlanningItemHeaderBadge>
                </PlanningItemHeader>
            }
            location={location} 
        />
    );
};